import "./PageEmpty.css";

export default function PageEmpty({ icon, title, description, action }) {
  return (
    <div className="page-empty">
      {icon && <div className="page-empty__icon">{icon}</div>}

      <h2>{title}</h2>

      {description && <p>{description}</p>}

      {action && <div className="page-empty__action">{action}</div>}
    </div>
  );
}
